import { parseISO } from 'date-fns';
import { useOrder } from '../orders';

export const useNextDeliveryTarget = (subscription, isLegacy) => {
  let nextDeliveryDate = null;

  const { order, isLoading } = useOrder(
    isLegacy ? subscription?.current_order_id : subscription?.current_order?.id,
  );
  const isLockedIn = isLegacy
    ? subscription?.is_locked_in
    : !!subscription?.current_order || subscription?.is_in_billing_period;

  if (!isLoading && isLockedIn) {
    nextDeliveryDate = parseISO(order?.delivery_date);
  } else if (subscription?.next_delivery_target) {
    nextDeliveryDate = parseISO(subscription?.next_delivery_target);
  }

  return {
    isNextDeliveryTargetLoading: subscription ? !nextDeliveryDate : false,
    nextDeliveryDate,
  };
};
